import { useQuery, useQueryClient } from 'react-query'
import axios from 'axios'

export const useGetPlaces = (searchString) => {
	return useQuery(['PlacesAPI', searchString], () =>
		axios
			.get(`/api/placesapi?search_string=${searchString}`)
			.then((res) => res.data.predictions || []),
	)
}

export const useGetQueryData = (configKey) => {
	const queryClient = useQueryClient()
	return queryClient.getQueryData(configKey)
}

/**
 * very important difference compared to the above.
 * This one, subscribes to cache at this query key, 
 * meaning when there are changes in that cache, the returned
 * data will update itself, rerendering the component
 * where it is called. The above wont do that. it just gets
 * the data once and is done with it.
 */
export const useSubscribeToQueryData = (queryKey) => {
  return useQuery({
    queryKey,
    enabled: false, // Won't trigger fetch, just subscribes to cache
  })
  
}

export const useGetQueryState = (configKey) => {
	const queryClient = useQueryClient()
	return queryClient.getQueryState(configKey)
}
